import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import URLS from "redux/urls";
import request from "redux/utils/request";

export const fetchAllEmployee = createAsyncThunk(
  "Employee/fetchAllEmployee",
  async (params, { rejectWithValue }) => {
    try {
      const response = await request("get", URLS.EMPLOYEE, params);
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const addEmployee = createAsyncThunk(
  "Employee/addEmployee",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await request("post", URLS.EMPLOYEE, payload);
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const updateEmployee = createAsyncThunk(
  "Employee/updateEmployee",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await request(
        "patch",
        `${URLS.EMPLOYEE}/${payload.id}`,
        payload
      );
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
export const fetchOneEmployee = createAsyncThunk(
  "Employee/fetchOneEmployee",
  async (id, { rejectWithValue }) => {
    try {
      const response = await request("get", `${URLS.EMPLOYEE}/${id}`);
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const deleteEmployee = createAsyncThunk(
  "Employee/deleteEmployee",
  async (id, { rejectWithValue }) => {
    try {
      const response = await request("delete", `${URLS.EMPLOYEE}/${id}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const initialState = {
  loading: {
    query: false,
    mutation: false,
  },
  filter: {
    q: "",
  },
  list: [],
  count: {},
  selected: {},
  selectedRows: [],
};

const loadingReducer = (fieldName, status) => (state) => {
  state.loading[fieldName] = status;
};

const startLoadingQuery = loadingReducer("query", true);
const stopLoadingQuery = loadingReducer("query", false);
const startLoadingMutation = loadingReducer("mutation", true);
const stopLoadingMutation = loadingReducer("mutation", false);

export const EmployeeSlice = createSlice({
  name: "Employee",
  initialState,
  reducers: {
    setAppliedSearchText: (state, action) => {
      state.filter.q = action.payload;
    },
    setSelectedRows: (state, action) => {
      state.selectedRows = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAllEmployee.pending, startLoadingQuery)
      .addCase(fetchAllEmployee.fulfilled, (state, action) => {
        state.list = action.payload;
        state.loading.query = false;
      })
      .addCase(fetchAllEmployee.rejected, stopLoadingQuery);
    builder
      .addCase(fetchOneEmployee.pending, startLoadingQuery)
      .addCase(fetchOneEmployee.rejected, stopLoadingQuery)
      .addCase(fetchOneEmployee.fulfilled, (state, action) => {
        state.loading.query = false;
        state.selected = action.payload;
      });
    builder
      .addCase(updateEmployee.pending, startLoadingQuery)
      .addCase(updateEmployee.rejected, stopLoadingQuery)
      .addCase(updateEmployee.fulfilled, (state, action) => {
        state.loading.query = false;
        state.selected = action.payload;
      });
    builder
      .addCase(deleteEmployee.pending, startLoadingMutation)
      .addCase(deleteEmployee.fulfilled, stopLoadingMutation)
      .addCase(deleteEmployee.rejected, stopLoadingMutation);
  },
});

export const { setSelectedRows, setAppliedSearchText } = EmployeeSlice.actions;

export default EmployeeSlice.reducer;
